export default __webpack_public_path__ + "static/media/ped_download.367bdfb5.svg";